import { alpha } from '@mui/material/styles';
import { colors } from 'src/theme';

// Used only by the Variance % row of the expanded detail (D-Q3).
export const variancePctStyle = (
  pct: string | null
): { backgroundColor?: string } => {
  if (pct === null) {
    return {};
  }

  const num = Number(pct);
  if (!Number.isFinite(num) || num === 0) {
    return {};
  }

  const absPct = Math.abs(num);
  let step: number;

  if (absPct < 1) {
    step = 0.15;
  } else if (absPct < 5) {
    step = 0.3;
  } else if (absPct < 10) {
    step = 0.45;
  } else {
    step = 0.6;
  }

  const color = num < 0 ? colors.red : colors.green;
  return { backgroundColor: alpha(color, step) };
};
